/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SiteComponentInfo } from './siteComponentInfo';
import { CdvxComponentInfo } from './cdvxComponentInfo';
import { SrmComponentInfo } from './srmComponentInfo';
import { IrrComponentInfo } from './irrComponentInfo';
import { VpcComponentInfo } from './vpcComponentInfo';
import { InventoryComponentType } from './inventoryComponentType';
import { ProviderComponentMetadata } from './providerComponentMetadata';
import { VcenterComponentInfo } from './vcenterComponentInfo';
import { DrcComponentInfo } from './drcComponentInfo';


/**
 * Component resource that can represent IRR, CDVX, DRC, Site, vCenter, SRM, or VPC
 */
export interface InventoryComponent { 
    /**
     * Component identifier
     */
    id: string;
    component_type: InventoryComponentType;
    image_id: string;
    /**
     * Component name
     */
    name?: string;
    /**
     * Component metadata
     */
    metadata?: Array<ProviderComponentMetadata>;
    drcComponentInfo?: DrcComponentInfo;
    irrComponentInfo?: IrrComponentInfo;
    cdvxComponentInfo?: CdvxComponentInfo;
    siteComponentInfo?: SiteComponentInfo;
    vcenterComponentInfo?: VcenterComponentInfo;
    srmComponentInfo?: SrmComponentInfo;
    vpcComponentInfo?: VpcComponentInfo;
    /**
     * Indicates if the component information is partial/incomplete
     */
    isComponentInfoPartial?: boolean;
}
export namespace InventoryComponent {
}


